import { Link } from "react-router-dom";
import { MapPin, MessageCircle } from "lucide-react";

export default function MobileBottomBar() {
  return (
    <div
      data-testid="mobile-bottom-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-6px_24px_rgba(15,23,42,0.08)] backdrop-blur-md md:hidden"
    >
      <div className="grid grid-cols-2 gap-3 p-3">
        <Link to="/#sedi" data-testid="mobile-bar-store" className="btn btn-outline btn-md w-full">
          <MapPin className="h-4 w-4" />
          TROVA NEGOZIO
        </Link>
        <Link to="/contatti" data-testid="mobile-bar-contact" className="btn btn-primary btn-md w-full">
          <MessageCircle className="h-4 w-4" />
          CONTATTACI
        </Link>
      </div>
    </div>
  );
}
